// Action Types
export const FETCH_SELF_FINANCIALS_REQUEST = "FETCH_SELF_FINANCIALS_REQUEST";
export const FETCH_SELF_FINANCIALS_SUCCESS = "FETCH_SELF_FINANCIALS_SUCCESS";
export const FETCH_SELF_FINANCIALS_FAILURE = "FETCH_SELF_FINANCIALS_FAILURE";

// Action Creators
export const fetchSelfFinancialsRequest = (ticker) => {
  return (dispatch) => {
    dispatch({
      type: FETCH_SELF_FINANCIALS_REQUEST,
      payload: ticker,
    });
  };
};
export const fetchSelfFinancialsSuccess = (products) => ({
  type: FETCH_SELF_FINANCIALS_SUCCESS,
  payload: products,
});
export const fetchSelfFinancialsFailure = (error) => ({
  type: FETCH_SELF_FINANCIALS_FAILURE,
  payload: error,
});
